import { getCore } from '../../../../client/core/getCore';
import type { DynamicClient } from '../../../../client/types';
import { getWalletAccounts } from '../../getWalletAccounts';
import type { WalletProvider } from '../../walletProvider';
import { getWalletProviderFromWalletAccount } from '../getWalletProviderFromWalletAccount';

export const getAvailableWalletProvidersFromWalletAccounts = (
  client: DynamicClient
) => {
  const core = getCore(client);

  const walletProvidersMap: Map<string, WalletProvider> = new Map();

  const walletAccounts = getWalletAccounts(client);

  walletAccounts.forEach((walletAccount) => {
    if (walletProvidersMap.has(walletAccount.walletProviderKey)) {
      return;
    }

    try {
      const walletProvider = getWalletProviderFromWalletAccount(
        {
          walletAccount,
        },
        client
      );

      walletProvidersMap.set(walletAccount.walletProviderKey, walletProvider);
    } catch (error) {
      core.logger.debug('Wallet provider not found for wallet account', {
        error,
        walletAccount: walletAccount.address,
      });
    }
  });

  return Array.from(walletProvidersMap.values());
};
